/**
 * 应用根组件。
 *
 * CapabilityProvider 放在最外层：探测必须全应用只跑一次（WebGL 上下文数量有限），
 * 且布局、导航、导演台入口都要读同一份结果。
 */
import { RouterProvider } from 'react-router-dom';

import { CapabilityProvider } from './app/CapabilityProvider';
import { router } from './app/router';

export default function App() {
  return (
    <CapabilityProvider>
      <RouterProvider router={router} />
    </CapabilityProvider>
  );
}
